var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackwardFast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 415.966V96.031C0 78.359 14.326 64.032 31.999 64.032H31.999C49.673 64.032 64 78.36 64 96.034V227.88L235.5 71.406C256.125 54.284 288 68.657 288 96.027V227.88L459.5 71.406C480.125 54.284 512 68.657 512 96.027V415.973C512 443.343 480.125 457.716 459.5 440.594L288 285.245V415.973C288 443.343 256.125 457.716 235.5 440.594L64 285.245V415.969C64 433.641 49.674 447.968 32.001 447.968H32.001C14.327 447.968 0 433.64 0 415.966Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardFast);
export default __webpack_public_path__ + "static/media/backward-fast.4fa1557f701e1f3f3fd2e19b46580f76.svg";
export { ForwardRef as ReactComponent };